// extracted by mini-css-extract-plugin
var _1 = "ra-carousel";
var _2 = "ra-carousel-item";
var _3 = "ra-artist-art-details-actions";
var _4 = "ra-artist-art-details";
var _5 = "ra-artist-art-details-position";
var _6 = "ra-artist-art-details-left";
var _7 = "ra-artist-art-details-price";
var _8 = "ra-artist-art-details-right";
var _9 = "ra-artist-art-details-status";
export { _1 as "artCarouselCls", _2 as "artCarouselItemCls", _3 as "artistArtDetailsActionsCls", _4 as "artistArtDetailsCls", _5 as "artistArtDetailsItemPositionCls", _6 as "artistArtDetailsLeftCls", _7 as "artistArtDetailsPriceCls", _8 as "artistArtDetailsRightCls", _9 as "artistArtDetailsStatusCls" }
